const roles = [
  { label: 'Member', value: 'MEMBER' },
  { label: 'Administrator', value: 'ADMINISTRATOR' },
  { label: 'Owner', value: 'OWNER' },
]

const userOptions = { roles }

export default userOptions
